module.exports = __webpack_public_path__ + "static/img/tm-2.58ac415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/tm-2.jpg
// module id = v4z8
// module chunks = 0